import { jsx as f } from "react/jsx-runtime";
import { forwardRef as v, useEffect as y } from "react";
import { useMultiStyleConfig as h } from "@chakra-ui/react";
import { p as x } from "../../floating-ui.react-5e63cf1f.js";
import { useDropdown as P, DropdownProvider as R, DropdownStylesProvider as I } from "./Dropdown.context.es.js";
function S(t, ...e) {
  return b(t) ? t(...e) : t;
}
var b = (t) => typeof t == "function";
const T = v(({ children: t, isTruncated: e = !0, onDropdownClose: r, onDropdownOpen: i, ...n }, s) => {
  const c = P({ forwardedRef: s, ...n }), u = h("Dropdown", {
    variant: e ? "truncated" : void 0
  }), { buttonRef: m, isOpen: o, nodeId: d, onClose: a, onOpen: l, onToggle: g, getReferenceProps: p } = c;
  return y(() => {
    o ? i == null || i() : r == null || r();
  }, [o]), /* @__PURE__ */ f(R, { value: c, children: /* @__PURE__ */ f(I, { value: u, children: /* @__PURE__ */ f(x, { id: d, children: S(t, {
    buttonRef: m,
    isOpen: o,
    onClose: a,
    onOpen: l,
    onToggle: g,
    getReferenceProps: p
  }) }) }) });
});
export {
  T as DropdownComponent
};
//# sourceMappingURL=Dropdown.component.es.js.map
